import { Sun, Moon } from "lucide-react";
import { useLandingTheme } from "@/context/LandingThemeContext";

export default function ThemeToggle() {
  const { theme, toggle } = useLandingTheme();
  const isDark = theme === "dark";

  return (
    <button
      onClick={toggle}
      data-testid="landing-theme-toggle"
      className="flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-medium transition-all duration-300"
      style={{
        background: isDark ? "rgba(255,255,255,0.04)" : "rgba(0,0,0,0.04)",
        border: `1px solid ${isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)"}`,
        color: isDark ? "rgba(255,255,255,0.7)" : "#334155",
      }}
      title={isDark ? "Modo claro" : "Modo escuro"}
    >
      {isDark ? <Sun className="w-4 h-4 text-orange-400" /> : <Moon className="w-4 h-4 text-slate-600" />}
    </button>
  );
}
